export const SpringAnimation = {
    INITIAL_X: 0,
    INITIAL_Y: 300,
    AFTER_X: 0,
    AFTER_Y: 0,
};